import { MetaData } from "../../models/metaData";

export interface MetaDataState {
  metaData: MetaData;
  isLoading: boolean;
  metaDataLoaded: boolean;
  isError: boolean;
}

export const META_DATA_REQUEST = "META_DATA_REQUEST";
export const META_DATA_FAILURE = "META_DATA_FAILURE";
export const LOAD_META_DATA_SUCCESS = "LOAD_META_DATA_SUCCESS";

export interface MetaDataRequestAction {
  type: typeof META_DATA_REQUEST;
}

export interface MetaDataFailureAction {
  type: typeof META_DATA_FAILURE;
}

export interface LoadMetaDataAction {
  type: typeof LOAD_META_DATA_SUCCESS;
  data: MetaData;
}

export type MetaDataActionTypes =
  | MetaDataRequestAction
  | MetaDataFailureAction
  | LoadMetaDataAction;
